import type { OrganizationUser } from '../organizationUsers.models';

export const markInvited = (
  entities: Record<string, OrganizationUser>,
  invitedUserIds: string[]
): Record<string, OrganizationUser> =>
  invitedUserIds.reduce(
    (prev, userId) =>
      prev[userId]
        ? { ...prev, [userId]: { ...prev[userId], status: 'INVITED' } }
        : prev,
    entities
  );

export const deriveInvitedUserIds = (
  userIds: string[],
  failed: { userId?: string }[]
): string[] => {
  const failedSet = new Set(
    failed.flatMap((f) => (f.userId ? [f.userId] : []))
  );
  return userIds.filter((id) => !failedSet.has(id));
};
